export enum TranslationsStringsType {
  TITLE = "Title",
  DESCRIPTION = "Description",
  MAINBUTTON = "MainButton",
  LEFTBUTTON = "LeftButton",
  VALUETITLE = "ValueTitle",
  PLACEHOLDER = "Placeholder",
}

export const CORE_STEP_NAMES = {
  PIN: "pin",
  RSVP: "rsvp",
  INTOLERANCES: "intolerances",
  ARRIVAL_DATE: "arrivalDate",
  BUS: "bus",
  EMAIL: "email",
  SUMMARY: "summary",
  FINAL: "final",
} as const;

type CoreStepName = (typeof CORE_STEP_NAMES)[keyof typeof CORE_STEP_NAMES];

export function isCoreStep(name: string): name is CoreStepName {
  return (Object.values(CORE_STEP_NAMES) as string[]).includes(name);
}

export enum BUTTON_CLICK {
  PREVIOUS_STEP = 0,
  NEXT_STEP = 1,
}

export enum ERROR_TYPE {
  INVITATION_NOT_FOUND = "invitation.notFound",
  RSVP_NOT_ENABLED = "rsvp.notEnabled",
  RSVP_CONFIRM_FAILED = "rsvp.failed",
}
